import { useState, useEffect } from 'react'
import Layout from '../../Frames/Layout'
import moment from 'moment/moment'
import Range from '../../Inputs/Range'
import Loader from '../../Tools/Loader'
import Free from './Free'
import Paid from './Paid'
import Process from './Process'
import Carts from './Carts'
import Conversions from './Conversions'
import Reviews from './Reviews'
import Sponsor from './Sponsor'
import API from '../../../services/API/CRM'
import { Stack } from '@mui/material'
import NewCustomers from './NewCustomers'
import NewUsers from './NewUsers'
import Origins from './Origins'
import FreeToPaid from './FreeToPaid'

export default function Index(){

    const [range, setRange] = useState(null)
    const [data, setData] = useState(null)

    useEffect(() => {

        const start = moment().format('YYYY') + '-01-01';
        const end = moment().format('YYYY-MM-DD');

        API.getStats(start, end)
            .then(r => setData(r.data))

        setRange({start, end});

    }, [])

    const handleRangeChange = rng => {
        setRange(rng)
        setData(null)
        API.getStats(rng.start, rng.end)
            .then(r => setData(r.data))
    }

    return <Layout tab='stats' title='Statistiques' menu="marketing">

        {data && <Stack spacing={3}>

            <Range 
                start={range?.start}
                end={range?.end}
                onChange={handleRangeChange}
            />
            
            <Free data={data.free_by_category}/>

            <Paid data={data.paid_by_category}/>

            <Process data={data.paid_by_process}/>

            <NewUsers data={data.new_users}/>

            <NewCustomers data={data.new_customers}/>

            <Carts data={data.customer_carts}/>

            <Conversions data={data.conversions}/>

            <FreeToPaid data={data.free_to_paid}/>

            <Reviews data={data.reviews}/>

            <Sponsor data={data.sponsor}/>

            <Origins data={data.origins}/>

        </Stack>}

        {!data && <Loader />}
        
    </Layout>
}